// extracted by mini-css-extract-plugin
export var label = "_db-2";
export var slideContainer = "_db-0";
export var slider = "_db-1";